import { readAsList } from '@onevision-resources/json-api-parser';
import { apiClient } from 'core/api';
import { AppThunk } from 'core/redux';
import { getNextPage } from 'core/redux/reducers/helpers';
import PartnerGroups from 'core/redux/reducers/partnerGroups';
import Partners from 'core/redux/reducers/partners';
import { ListReducerState } from 'core/redux/reducers/types';

export const fetchPartners =
  (options: Partial<ListReducerState> = {}, listId?: string): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();
    const listState = Partners.selectors.selectList(state, listId || '');
    const nextPage = getNextPage(options.page, listState);

    const limit = options.perPage || listState.perPage;
    const offset = limit * (nextPage - 1);

    delete options.perPage;
    const apiResponse = await apiClient.getPartners({
      include: listState.include,
      search: listState.search,
      ...options,
      page: {
        limit,
        offset,
      },
    });

    const {
      data: {
        meta: { page, defaultPage, ...meta },
      },
    } = apiResponse;

    const { entities } = readAsList(apiResponse.data);

    const { Partner, PartnerGroup } = entities;

    if (Partner) {
      dispatch(
        Partners.actions.batch([
          Partners.actions.updateList(
            {
              ...meta,
              ids: Partner.map((e) => e.id),
              page: page ? page.offset / page.limit + 1 : nextPage,
              perPage: page ? +page.limit : listState.perPage,
              lastPage: Math.ceil(
                meta.totalCount / (page ? page.limit : listState.perPage),
              ),
            },
            listId,
          ),
          Partners.actions.upsertMany(Partner),
        ]),
      );
    }

    if (PartnerGroup) {
      dispatch(PartnerGroups.actions.upsertMany(PartnerGroup));
    }
  };
